import { Controller } from "@hotwired/stimulus";

/**
 * @see https://www.bram.us/2020/05/06/100vh-in-safari-on-ios/
 */
export default class extends Controller {
  debounceTimer = null;

  /**
   * @see https://www.bram.us/2020/05/06/100vh-in-safari-on-ios/
   */
  initialize() {
    window.addEventListener("load", this.setVh);
    window.addEventListener("resize", () => {
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }

      this.debounceTimer = setTimeout(() => this.setVh(), 100);
    });
  }

  setVh() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  }
}
